export * from "./avatar"
export * as AvatarStyles from "./avatar.styled"
